import * as React from "react";

interface IProps {
    className?: string;
}

class IconHBRPause extends React.Component<IProps> {
    public render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className={this.props.className} viewBox="0 0 19 26" >
                <g>
                    <rect x="1" y="2.5" width="7" height="21" />
                    <rect x="11" y="2.5" width="7" height="21" />
                </g>
            </svg>
        );
    }
}

export default IconHBRPause;
